import {
  Box,
  Grid,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BackButton, Button, Heading, Modal } from "../../components/Common";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AdminChnagePasswordOnMail,
  AuditorCreate,
  AuditorDetail,
  AuditorUpdate,
  DeviceDelete,
} from "../../Service/Auditor.service";
import { notificationSuccess } from "../../state/Action/NotificationAction";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { addAuditorInitialValues } from "../../helper/initialValues";
import {
  addAdminValidationSchema,
  addAuditorValidationSchema,
} from "../../helper/validation";
import { IsWrite } from "../../helper/handlePermission";

const AuditorsDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const editPermissions = IsWrite("Auditor");

  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    currentComponent: "",
    para: "",
    head: "",
  });
  const [auditorData, setAuditorData] = useState({});

  const handleActiveSurveyClick = () => {
    if (!auditorData || !auditorData._id) return;
    navigate("/form-management", {
      state: {
        auditorId: auditorData._id,
        auditorName: `${auditorData.firstName || ""} ${auditorData.lastName || ""}`.trim(),
        status: 1,
      },
    });
  };

  const handleSubmittedSurveyClick = () => {
    if (!auditorData || !auditorData._id) return;
    sessionStorage.removeItem("submitted_form_filters");
    sessionStorage.setItem(
      "submitted_form_filters",
      JSON.stringify({
        fromSubmitDate: "",
        toSubmitDate: "",
        auditor: auditorData._id,
        formId: "",
      })
    );
    sessionStorage.setItem("submitted_form_page", 0);
    navigate("/submited-form", {
      state: {
        auditorId: auditorData._id,
        auditorName: `${auditorData.firstName || ""} ${auditorData.lastName || ""}`.trim(),
      },
    });
  };

  const auditorId =
    typeof state === "object"
      ? state?.id || state?._id
      : state || sessionStorage.getItem("current_auditor_id");

  useEffect(() => {
    const id = typeof state === "object" ? state?.id || state?._id : state;
    if (id) {
      sessionStorage.setItem("current_auditor_id", id);
      fetchAuditorData(id);
    } else {
      const savedId = sessionStorage.getItem("current_auditor_id");
      if (savedId) {
        fetchAuditorData(savedId);
      }
    }
  }, [state]);

  const formik = useFormik({
    initialValues: addAuditorInitialValues,
    onSubmit: async (value) => {
      const payload = {
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        mobile: value.mobile,
        location: value.location,
      };

      let res = await AuditorUpdate(auditorId, payload);
      if (res?.status) {
        dispatch(
          notificationSuccess({
            show: true,
            type: "success",
            message: res.message || "Success",
          })
        );
        setIsModalOpen({
          open: false,
          currentComponent: "",
          para: "",
          head: "",
          isEdit: false,
          isView: false,
        });
        fetchAuditorData(auditorId);
        formik.resetForm();
      } else {
        dispatch(
          notificationSuccess({
            show: true,
            type: "error",
            message:
              res.message || "Something went wrong. Please try again later.",
          })
        );
      }
    },
    validationSchema: addAuditorValidationSchema,
  });
  const fetchAuditorData = async (id) => {
    try {
      const res = await AuditorDetail(id);
      if (res?.status) {
        setAuditorData(res?.data);
      } else {
        setAuditorData({});
      }
    } catch (error) {
      console.error("Error fetching auditor data:", error);
    }
  };

  const changeStatus = async () => {
    let res =
      isModalOpen && isModalOpen?.currentComponent == "delete"
        ? await DeviceDelete(isModalOpen?.id)
        : isModalOpen && isModalOpen?.currentComponent == "changepassword"
        ? await AdminChnagePasswordOnMail(isModalOpen?.id)
        : null;

    if (res?.status) {
      dispatch(
        notificationSuccess({
          show: true,
          type: "success",
          message: res.message || "Success",
        })
      );
      fetchAuditorData(auditorId);
      setIsModalOpen({
        open: false,
        currentComponent: "",
        para: "",
        head: "",
        id: "",
      });
    } else {
      dispatch(
        notificationSuccess({
          show: true,
          type: "error",
          message:
            res.message || "Something went wrong. Please try again later.",
        })
      );
    }
  };

  return (
    <>
      <Heading head={"Auditor Details"} />
      <Stack gap={2} mt={1}>
        <Stack
          mb={1}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Stack
            flexDirection={"row"}
            justifyContent={"flex-start"}
            gap={1}
            alignItems={"center"}
          >
            <BackButton />
          </Stack>
          <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
            {editPermissions && (
              <>
                <Button
                  buttonName={"Edit"}
                  onClick={() => {
                    formik.setFieldValue("firstName", auditorData?.firstName);
                    formik.setFieldValue("lastName", auditorData?.lastName);
                    formik.setFieldValue("email", auditorData?.email);
                    formik.setFieldValue("mobile", auditorData?.mobile);
                    formik.setFieldValue("location", auditorData?.location);
                    setIsModalOpen({
                      open: true,
                      currentComponent: "addauditor",
                      id: auditorId,
                      isEdit: true,
                    });
                  }}
                  size="small"
                />

                <Button
                  buttonName={"Change Password"}
                  style={{ padding: "10px 11px" }}
                  color="white"
                  size="small"
                  variant="contained"
                  onClick={() => {
                    setIsModalOpen({
                      open: true,
                      currentComponent: "changepassword",
                      head: "Change Password",
                      para: "Are You Sure to Change Password?",
                      id: auditorId,
                    });
                  }}
                  sx={{ mt: 2 }}
                />
              </>
            )}
          </Stack>
        </Stack>
        <Stack
          gap={2}
          sx={{
            flexDirection: { xs: "column", md: "row" },
            alignItems: "stretch",
          }}
        >
          <Box
            className="auditorinfo_card"
            sx={{
              flex: 2,
            }}
          >
            <Typography sx={{ fontWeight: 600, mb: 1.5, fontSize: "16px" }}>
              Auditor Information
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <span>Name:</span> {auditorData.firstName}{" "}
                  {auditorData.lastName}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <span>Mobile Number:</span> {auditorData.mobile}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <span>Email:</span> {auditorData.email}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography>
                  <span>Location:</span> {auditorData.location}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Stack direction={{ xs: "column", sm: "row" }} gap={2} sx={{ flex: 1 }}>
            <Box
              className="active_survey"
              onClick={handleActiveSurveyClick}
              title="Click to view active forms for this auditor"
              sx={{
                flex: 1,
                minWidth: "150px",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border: "1px solid #e0e0e0",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 6px 16px rgba(218, 41, 33, 0.15)",
                  borderColor: "#DA2921",
                },
              }}
            >
              <Typography sx={{ display: "flex", flexDirection: "column" }}>
                <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <span>Active Survey</span>
                  <span style={{ fontSize: "11px", color: "#888", fontWeight: 400 }}>View Forms ↗</span>
                </span>
                <span style={{ fontSize: "24px", fontWeight: "bold", color: "#DA2921", marginTop: "8px" }}>
                  {auditorData.activeSurvey ?? 0}
                </span>
              </Typography>
            </Box>
            <Box
              className="active_survey"
              onClick={handleSubmittedSurveyClick}
              title="Click to view all submitted surveys by this auditor"
              sx={{
                flex: 1,
                minWidth: "150px",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                border: "1px solid #e0e0e0",
                "&:hover": {
                  transform: "translateY(-3px)",
                  boxShadow: "0 6px 16px rgba(0, 0, 0, 0.12)",
                  borderColor: "#333",
                },
              }}
            >
              <Typography sx={{ display: "flex", flexDirection: "column" }}>
                <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <span>Submitted Surveys</span>
                  <span style={{ fontSize: "11px", color: "#888", fontWeight: 400 }}>View Submissions ↗</span>
                </span>
                <span style={{ fontSize: "24px", fontWeight: "bold", color: "#333", marginTop: "8px" }}>
                  {auditorData.numOfSurvey ?? 0}
                </span>
              </Typography>
            </Box>
          </Stack>
        </Stack>

        <Stack gap={1} mt={1}>
          <Heading smallHead={"Devices"} />
          <TableContainer>
            <Table stickyHeader aria-label="devices table">
              <TableHead>
                <TableRow>
                  <TableCell style={{ textAlign: "left", fontWeight: 600 }}>Device-Id</TableCell>
                  <TableCell style={{ textAlign: "left", fontWeight: 600 }}>Device Name</TableCell>
                  <TableCell style={{ textAlign: "left", fontWeight: 600 }}>Model</TableCell>
                  <TableCell style={{ textAlign: "left", fontWeight: 600 }}>Device Version</TableCell>
                  {editPermissions && (
                    <TableCell align="center" style={{ fontWeight: 600, width: "120px" }}>Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {auditorData &&
                Array.isArray(auditorData.devices) &&
                auditorData.devices.length > 0 ? (
                  auditorData.devices.map((item, index) => (
                    <TableRow
                      key={item._id || item.deviceId || index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        className="table-hover"
                        style={{ textAlign: "left" }}
                      >
                        {item.deviceId}
                      </TableCell>
                      <TableCell
                        className="table-hover"
                        style={{ textAlign: "left" }}
                      >
                        {item.deviceName}
                      </TableCell>
                      <TableCell
                        className="table-hover"
                        style={{ textAlign: "left" }}
                      >
                        {item.model}
                      </TableCell>
                      <TableCell
                        className="table-hover"
                        style={{ textAlign: "left" }}
                      >
                        {item.deviceVersion}
                      </TableCell>
                      {editPermissions && (
                        <TableCell align="center">
                          <Button
                            buttonName={"Delete"}
                            style={{ padding: "6px 14px", minWidth: "unset" }}
                            size="small"
                            onClick={() => {
                              setIsModalOpen({
                                open: true,
                                currentComponent: "delete",
                                para: "Are You Sure to Delete Device?",
                                id: item._id || item.deviceId,
                              });
                            }}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={editPermissions ? 5 : 4}
                      align="center"
                      sx={{ py: 3, color: "text.secondary" }}
                    >
                      No devices found.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Stack>
      <Modal
        modalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        formik={formik}
        handleClose={() => {
          setIsModalOpen({ open: false, currentComponent: "", id: "" });
          formik.resetForm();
        }}
        handelClick={changeStatus}
      />
    </>
  );
};

export default AuditorsDetails;
